import React, { useEffect, useState } from "react";
import Popup from "./Popup";
import '../App.css';
import './NewItem.css'; // Nuevo archivo de estilos
import Button from "./Button";
import Table1 from "./Table1";
import AddObjectType from './AddObjectType'; // o la ruta correcta

import EditText from "./EditText"
import { useReducer } from "react";
import Dropdown2 from "./Dropdown2";
import Dropdown from "./Dropdown";
import { reducer,initialState } from "../reducers/reducers";
import DropdownSearch from "./DropdownSearch";
import API_URLS from "../Urls";
import Checkbox from "./Checkbox";

import Alert from "./Alert";

const ITEM_TYPES = [
  { label: 'Servicio', color: '#318acc', icon: '🛠️' },
  { label: 'Dron Enterprise', color: '#61BAA5', icon: '🚁' },
  { label: 'Dron Comercial', color: '#f7b731', icon: '🚁' },
  { label: 'Accesorio', color: '#8854d0', icon: '🔌' },
  { label: 'Parte', color: '#eb3b5a', icon: '⚙️' }
];

const NewItem = ({ selectedType, onClose, onAccept }) => {
    const [type, setType] = useState(selectedType);
    const [state, dispatch] = useReducer(reducer, initialState);
    const [dataToSend, setDataToSend] = useState();
    const [typeToAdd, setTypeToAdd] = useState()
    const [selectedDrones, setSelectedDrones] = useState([]);
    const [selectedDrone, setSelectedDrone] = useState("");
    const [fetchedDrones, setFetchedDrones] = useState([]);
    const [compatibleDrones,setCompatibleDrones] = useState([]);
    const [objectTypes, setObjectTypes] = useState([])
    const [url, setUrl] = useState(''); // Use state for URL
    useEffect(()=>{console.log(type)},[type])
    const fetchId = (url,id,onSuccesful) => {

        fetch(url+"?id="+id, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
            
        })
        .then(response => {
            if (!response.ok) throw new Error('Network response was not ok ' + response.statusText);
            return response.json();
        })
        .then(data => {
            console.log(data)
            if (data.length > 0) {
                alert('id ya existe')
            } else {
                
                if (typeof onSuccesful === 'function') onSuccesful(data);
            }
        })
        .catch(error => console.error('There was a problem with the fetch operation:', error));
    }   
    const validateFields = () => {
        const requiredFieldsByType = {
            'Servicio': ['id', 'nombre', 'linea', 'precio'],
            'Dron Enterprise': ['id', 'serie', 'modelo', 'precio'],
            'Dron Comercial': ['id', 'serie', 'modelo', 'precio'],
            'Accesorio': ['id', 'tipo','modelo', 'precio'],
            'Parte': ['id', 'tipo','modelo', 'precio']
        };
    
        const numericFields = ['precio']; // Add more fields here if needed
    
        const missingFields = [];
        const invalidFields = [];
    
        const requiredFields = requiredFieldsByType[type] || [];
    
        requiredFields.forEach(field => {
            const value = dataToSend[field];
    
            if (value === undefined || value === '') {
                missingFields.push(field);
            } else if (numericFields.includes(field)) {
                const num = parseFloat(value);
                if (isNaN(num)) {
                    invalidFields.push(field);
                }
            }
        });
    
        if (missingFields.length > 0 || invalidFields.length > 0) {
            let message = '';
            if (missingFields.length > 0) {
                message += `Faltan los siguientes campos: ${missingFields.join(', ')}.\n`;
            }
            if (invalidFields.length > 0) {
                message += `Los siguientes campos deben ser números válidos: ${invalidFields.join(', ')}.`;
            }
            alert(message);
            return false;
        }
    
        return true;
    };
    
    const postData = (url, dataToSend, onSuccesful) => {
        console.log("Posting to URL:", url); // Check URL during each post
        console.log("Data to send:", dataToSend);

        fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(dataToSend)
        })
        .then(response => {
            if (!response.ok) throw new Error('Network response was not ok ' + response.statusText);
            return response.json();
        })
        .then(data => {
            if (typeof onSuccesful === 'function') onSuccesful(data);
            console.log(data);
        })
        .catch(error => console.error('There was a problem with the fetch operation:', error));
    };

    const fetchDrones = () => {
        fetch(API_URLS.DRONES, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        })
        .then(response => {
            if (!response.ok) throw new Error('Network response was not ok ' + response.statusText);
            return response.json();
        })
        .then(data => {
            setFetchedDrones(data);
            
        })
        .catch(error => console.error('There was a problem with the fetch operation:', error));
    };
    const fetchData =(url,onSuccesful)=>{
        console.log(url)
        fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }})
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok ' + response.statusText);
            }
            return response.json();
        })
        .then(data => {
          console.log(data)
          if (typeof onSuccesful === 'function') onSuccesful(data) })// Update the state with fetched data})
        .catch(error => console.error('There was a problem with the fetch operation:', error));}
    const fetchTypes = (type) => {
        fetchData(API_URLS.OBJECTTYPES + "?objecttype=" + type,(data)=>{
            setObjectTypes(["Agregar tipo",...data.map(item=>item.tipo)])
        })
    }
    useEffect(() => {
        setSelectedDrones([]);
        fetchDrones();
        fetchTypes(type);
        // Set `dataToSend` and `url` based on `type`
        switch (type) {
            case 'Servicio':
                setDataToSend({});
                setUrl(API_URLS.SERVICES);
                break; 
            case 'Dron Enterprise':
                setDataToSend({ linea: 'Enterprise' });
                setUrl(API_URLS.DRONES);
                break;
            case 'Dron Comercial':
                setDataToSend({ linea: 'Comercial' });
                setUrl(API_URLS.DRONES);
                break;
            case 'Accesorio':
                setDataToSend({linea: 'Comercial'});
                setUrl(API_URLS.ACCESORIES);
                break;
            case 'Parte':
                setDataToSend({ });
                setUrl(API_URLS.PARTS);
                break;
            default:
                setDataToSend({});
                setUrl('');
                break;
        }
    }, [type]);

    const form = (option) => {
        switch (option) {
            case 'Servicio':
                return(
                    <div className="invisible-horizontal-container">
                        <Table1 headers={['id_servicio','Nombre', 'Linea', 'Precio','IVA']} data={[{
                            id_servicio: <EditText onChange={(text) => setDataToSend(prev => ({ ...prev, id: text }))} text={'Id del servicio'}></EditText>,
                            serie: <EditText onChange={(text) => setDataToSend(prev => ({ ...prev, nombre: text }))} text={'nombre'}></EditText>,
                            modelo:<Dropdown returnSelectedOption={(option) => setDataToSend(prev => ({ ...prev, linea: option }))} options={['Comercial','Enterprise']}></Dropdown>,
                            precio: <EditText onChange={(text) => setDataToSend(prev => ({ ...prev, precio: parseFloat(text) }))} text={'precio'}></EditText>,
                            iva: <Checkbox checked={true} label="precio ya incluye iva?" onChange={isChecked=>{setDataToSend(prev => ({ ...prev, iva_included: isChecked}))}}></Checkbox>

                        }]}></Table1>
                    </div>
                );
            case 'Dron Enterprise':
                return (
                    <div className="invisible-horizontal-container">
                        <Table1 headers={['id_dron','Serie', 'Modelo', 'Precio','IVA']} data={[{
                            id: <EditText onChange={(text) => setDataToSend(prev => ({ ...prev, id: text }))} text={'serie'}></EditText>,
                            serie: <EditText onChange={(text) => setDataToSend(prev => ({ ...prev, serie: text }))} text={'serie'}></EditText>,
                            modelo: <EditText onChange={(text) => setDataToSend(prev => ({ ...prev, modelo: text }))} text={'modelo'}></EditText>,
                            precio: <EditText onChange={(text) => setDataToSend(prev => ({ ...prev, precio: parseFloat(text) }))} text={'precio'}></EditText>,
                            iva: <Checkbox checked={true} label="precio ya incluye iva?" onChange={isChecked=>{setDataToSend(prev => ({ ...prev, iva_included: isChecked}))}}></Checkbox>

                        }]}></Table1>
                    </div>
                );
            case 'Dron Comercial':
                return (
                    <div className="invisible-horizontal-container">
                        <Table1 headers={['id_dron','Serie', 'Modelo', 'Precio','IVA']} data={[{
                            id: <EditText onChange={(text) => setDataToSend(prev => ({ ...prev, id: text }))} text={'serie'}></EditText>,
                            serie: <EditText onChange={(text) => setDataToSend(prev => ({ ...prev, serie: text }))} text={'serie'}></EditText>,
                            modelo: <EditText onChange={(text) => setDataToSend(prev => ({ ...prev, modelo: text }))} text={'modelo'}></EditText>,
                            precio: <EditText onChange={(text) => setDataToSend(prev => ({ ...prev, precio: parseFloat(text) }))} text={'precio'}></EditText>,
                            iva: <Checkbox checked={true} label="precio ya incluye iva?" onChange={isChecked=>{setDataToSend(prev => ({ ...prev, iva_included: isChecked}))}}></Checkbox>
                        }]}></Table1>
                    </div>
                );
            case 'Accesorio':
                return (
                    <div>
                        <div className="invisible-horizontal-container">
                            <Table1 headers={['id_accesorio','Tipo','Modelo','Precio','IVA' ]} data={[{
                                id_accesorio: <EditText onChange={(text) => setDataToSend(prev => ({ ...prev, id: text }))} text={'id_accesorio'}></EditText>,
                                tipo:<Dropdown placeholder={'Seleccione el tipo'}returnSelectedOption={(data)=>{
                                    if(data=="Agregar tipo"){
                                        setTypeToAdd('Accesorio')
                                        dispatch({ type: 'openAddObjectType' })
                                    } else {
                                        
                                        setDataToSend(prev => ({ ...prev, tipo:data }))
                                    }
                                }} options={objectTypes} />,
                                nombre: <EditText onChange={(text) => setDataToSend(prev => ({ ...prev, modelo: text }))} text={'Modelo'}></EditText>,
                                precio: <EditText onChange={(text) => setDataToSend(prev => ({ ...prev, precio: parseFloat(text) }))} text={'Precio'}></EditText>,
                                iva: <Checkbox checked={true} label="Precio ya incluye iva?" onChange={isChecked=>{setDataToSend(prev => ({ ...prev, iva_included: isChecked}))}}></Checkbox>

                                
                            }]}></Table1>
                        </div>
                        <div className="header1">Agregar compatibilidad con dron</div>
                        <div style={{ width: '100%' }}>
                            Linea:
                                <Dropdown options={['Comercial','Enterprise']} returnSelectedOption={(data)=>setDataToSend({...dataToSend,linea:data})}></Dropdown>
                                Serie:
                                <DropdownSearch placeholder={'Seleccione la serie'} returnSelectedOption={(data)=>{setDataToSend({...dataToSend, serie: data})}} options={[...new Set(fetchedDrones.filter(item => item.linea === dataToSend.linea).map(item => item.serie))]}></DropdownSearch>
                                Modelo:
                                <DropdownSearch placeholder={'Seleccione el modelo'} keys={fetchedDrones.filter(item => item.serie == dataToSend.serie && item.linea == dataToSend.linea).map(item => item.id)} returnSelectedOption={(data)=>{setDataToSend(prev => ({ ...prev, modelo: data }));}} returnSelectedKey={(data)=>{setDataToSend(prev => ({ ...prev, dron: data }));}} options={fetchedDrones.filter(item => item.serie == dataToSend.serie && item.linea == dataToSend.linea).map(item => item.modelo)}></DropdownSearch>
                                <Button onClick={()=>{
                                    if(dataToSend.linea && dataToSend.serie && dataToSend.modelo && dataToSend.dron){
                                        setCompatibleDrones(prev=>[...prev,{ id_dron : dataToSend.dron, linea : dataToSend.linea, serie : dataToSend.serie, modelo:dataToSend.modelo}])
                                    } else {
                                        alert('Seleccione todos los campos')
                                    }
                                    
                                }} color="#7AACE3" text='Añadir'></Button>
                                 </div>
                                <Table1 headers={['Id','Linea','Serie','Modelo']} optdelete={true} onClickDelete={(data)=>{setCompatibleDrones(compatibleDrones.filter(item=>item.id_dron!=data.id_dron))}}data={compatibleDrones}></Table1>
                        </div>);
            case 'Parte':
                return (
                    <div className="invisible-horizontal-container">
                        {fetchedDrones.length > 0 ? (
                            <div>
                            <Table1 headers={['id_parte','Tipo','Modelo',  'Precio','IVA']} data={[{
                                id_parte: <EditText onChange={(text) => setDataToSend(prev => ({ ...prev, id: text }))} text={'id_parte'}></EditText>,
                                tipo:<Dropdown placeholder={'Seleccione el tipo'} returnSelectedOption={(data)=>{
                                    if(data=="Agregar tipo"){
                                        setTypeToAdd('Parte')
                                        dispatch({ type: 'openAddObjectType' })
                                    } else {
                                        setDataToSend(prev => ({ ...prev, tipo:data }))
                                    }
                                }} options={objectTypes} />,
                                nombre: <EditText onChange={(text) => setDataToSend(prev => ({ ...prev, modelo: text }))} text={'Modelo'}></EditText>,
                                
                                precio: <EditText onChange={(text) => setDataToSend(prev => ({ ...prev, precio: parseFloat(text) }))} text={'Precio'}></EditText>,
                                iva: <Checkbox checked={true} label="precio ya incluye iva?" onChange={isChecked=>{setDataToSend(prev => ({ ...prev, iva_included: isChecked}))}}></Checkbox>
                            
                            }]}></Table1>
                            <div className="header1">Añadir drones compatibles</div>
                        <div style={{ width: '100%' }}>
                            <div className='invisible-horizontal-container'>
                                Linea:
                                <Dropdown options={['Comercial','Enterprise']} returnSelectedOption={(data)=>setDataToSend({...dataToSend,linea:data})}></Dropdown>
                                Serie:
                                <DropdownSearch placeholder={'Seleccione la serie'} returnSelectedOption={(data)=>{setDataToSend({...dataToSend, serie: data})}} options={[...new Set(fetchedDrones.filter(item => item.linea === dataToSend.linea).map(item => item.serie))]}></DropdownSearch>
                                Modelo:
                                <DropdownSearch placeholder={'Seleccione el modelo'} keys={fetchedDrones.filter(item => item.serie == dataToSend.serie && item.linea == dataToSend.linea).map(item => item.id)} returnSelectedOption={(data)=>{setDataToSend(prev => ({ ...prev, modelo: data }));}} returnSelectedKey={(data)=>{setDataToSend(prev => ({ ...prev, dron: data }));}} options={fetchedDrones.filter(item => item.serie == dataToSend.serie && item.linea == dataToSend.linea).map(item => item.modelo)}></DropdownSearch>
                                <Button onClick={()=>{
                                    if(dataToSend.linea && dataToSend.serie && dataToSend.modelo && dataToSend.dron){
                                        setCompatibleDrones(prev=>[...prev,{ id_dron : dataToSend.dron, linea : dataToSend.linea, serie : dataToSend.serie, modelo:dataToSend.modelo}])
                                    } else {
                                        alert('Seleccione todos los campos')
                                    }
                                    
                                }} color="#7AACE3" text='Añadir'></Button>
                                 </div>
                                <Table1 headers={['Id','Linea','Serie','Modelo']} optdelete={true} onClickDelete={(data)=>{setCompatibleDrones(compatibleDrones.filter(item=>item.id_dron!=data.id_dron))}}data={compatibleDrones}></Table1>
                        </div>
                            </div>
                        ) : (<div> Cargando...</div>)}
                    </div>
                );
            default:
                return null;
        }
    };

    return (
        <Popup title={"Agregar item al catalogo"} onClose={onClose}>
            <div className="invisible-horizontal-container">
                Tipo:
                <Dropdown2 value={type}returnSelectedOption={(option) => setType(option)} options={['Servicio','Dron Enterprise', 'Dron Comercial', 'Accesorio', 'Parte']} />
            </div>
            {form(type)}
            <div className="justify-right">
                <Button onClick={() => {
                    if (!validateFields())  return;
                    fetchId(url,dataToSend.id,() => {
                        const finalData = {
                            ...dataToSend,
                            precio: dataToSend.iva_included
                              ? dataToSend.precio * 1.16
                              : dataToSend.precio,
                          };
                        postData(url, finalData, (data) => {
                            const url = type=='Accesorio' ? API_URLS.DRONES_ACCESORIES : API_URLS.DRONES_PARTS
                            const field = type=='Accesorio' ? 'id_accesorio' : 'id_parte'
                            if (compatibleDrones.length > 0 && data.success) {
                                compatibleDrones.forEach(item => {
                                postData(url, { id_dron: item.id_dron, [field]: dataToSend.id });
                                });
                            }
                           onAccept();
                            });
                    })
                        
                }} color={"#61BAA5"} text={"Agregar"} />

            </div>
            {state.statusAddObjectType && (
                <AddObjectType tipo={typeToAdd} onAccept={()=>{dispatch({ type: 'closeAddObjectType' }); fetchTypes(type)}}onCancel={()=>dispatch({ type: 'closeAddObjectType' })} />
            )}
        </Popup>
    );
};

export default NewItem;